// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 20H0V4H16V20ZM4 14H10V12H4V14ZM4 10H12V8H4V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 20H18V4H24V20Z"}}]};

const TextDrawingFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'text-drawing-filled',
    ref,
    icon: element,
  },
));

TextDrawingFilledIcon.displayName = 'TextDrawingFilledIcon';

export default TextDrawingFilledIcon;
